import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Chart from './Chart';
import Totals from './Totals';
import InvoiceChart from '../invoice_plan/InvoiceChart';
import RevenueRecognition from '../../revenue_recognition/RevenueRecognition';
import {BudgetDataWrapper, ChartAndHighLevelNumbers, RevenueRecognitionWrapper} from '../../BudgetData.styled';
import HighLevelBudgetNumbers from '../../HighLevelBudgetNumbers';
import ProjectUtil from '../../../../../../forecast-app/shared/util/ProjectUtil';
import {hasFeatureFlag} from '../../../../../../forecast-app/shared/util/FeatureUtil';
import {BUDGET_MONEY_VIEWS} from '../../../../../../constants';

const BudgetData = ({
	project,
	company,
	selectValueType,
	selectedViewType,
	eyeOptionMap,
	hasBaseline,
	retry,
	timestamp,
	hasExpenses,
}) => {
	return (
		<BudgetDataWrapper>
			<ChartAndHighLevelNumbers>
				{BUDGET_MONEY_VIEWS.INVOICE_PLAN === selectedViewType ? (
					<InvoiceChart project={project} eyeOptionMap={eyeOptionMap} />
				) : (
					<Chart
						project={project}
						selectedViewType={selectedViewType}
						eyeOptionMap={eyeOptionMap}
						hasBaseline={hasBaseline}
					/>
				)}
				<HighLevelBudgetNumbers key={'HighLevelBudgetNumbers'} project={project} company={company} />
			</ChartAndHighLevelNumbers>
			<Totals
				company={company}
				project={project}
				eyeOptionMap={eyeOptionMap}
				selectValueType={selectValueType}
				hasBaseline={hasBaseline}
			/>
			{ProjectUtil.projectHasRevenueRecognition(project.budgetType) &&
				!hasFeatureFlag('financial_categories_update') &&
				BUDGET_MONEY_VIEWS.INVOICE_PLAN !== selectedViewType && (
					<RevenueRecognitionWrapper>
						<RevenueRecognition
							project={project}
							retry={retry}
							timestamp={timestamp}
							hideLocking={true}
							hasExpenses={hasExpenses}
						/>
					</RevenueRecognitionWrapper>
				)}
		</BudgetDataWrapper>
	);
};

export default createFragmentContainer(BudgetData, {
	company: graphql`
		fragment BudgetData_company on Company {
			tier
			...HighLevelBudgetNumbers_company
		}
	`,
	project: graphql`
		fragment BudgetData_project on ProjectType
		@argumentDefinitions(currentYear: {type: "Int"}, currentMonth: {type: "Int"}, currentMonthLastDay: {type: "Int"}) {
			...Chart_project
			...HighLevelBudgetNumbers_project
				@arguments(currentYear: $currentYear, currentMonth: $currentMonth, currentMonthLastDay: $currentMonthLastDay)
			...Totals_project
			...InvoiceChart_project
			...RevenueRecognition_project
			id
			billable
			budgetType
		}
	`,
});
